import { useEffect, useRef } from "react";
import ScrollReveal from "./Hooks/ScrollReveal";

const About = ({ aboutData }) => {
    const descRef = useRef(null);
    
    useEffect(() => {
        descRef.current.innerHTML = aboutData.description;
    }, []);

    return (
        <section id="about" style={{ height: '100%' }}>

            <div className="flex flex-col sm:justify-end justify-center" style={{ height: '100%' }}>
                {aboutData.display &&
                    <ScrollReveal>
                        <div className=" font-openSans font-semibold uppercase ">
                            <span className="text-4xl  block mb-0">{aboutData.title1}</span>
                            <span className="text-4xl block mt-0   ">{aboutData.title2}</span>
                        </div>
                        <div className="mt-4">
                            <p className="uppercase  font-openSans font-medium text-gray-600 text-sm sm:text-775rem " ref={descRef}>
                                {/* {aboutData.description} */}
                            </p>
                        </div>

                        <div className="mt-4 text-775rem animate-bounce hover:animate-none">
                            <a  className="underline decoration-sky-600  underline-offset-1 decoration-2   text-sky-600 hover:no-underline  sm:underline-offset-0 font-openSans font-semibold  "
                            href={aboutData.resumeLink}
                            >RESUME.pdf</a>
                        </div>
                    </ScrollReveal>}
            </div>

        </section>

    );
};

export default About;